import React, { PropsWithChildren, ReactNode } from 'react';
import classNames from 'classnames';
import styled from '@emotion/styled';

import { semantic_colors } from '../../../foundation';
import { IconCircleCheck } from '../../icons/generated';
import { Stack } from '../../stack';
import { BaseText } from '../../text';

export interface PanelTabGroupProps {
  title?: ReactNode;
  important?: boolean;
  className?: string;
}

export const PanelTabGroup = ({ title, important, className, children }: PropsWithChildren<PanelTabGroupProps>) => {
  return (
    <TabsContainer direction='column' data-testid='panel-tab-group'>
      {title &&
        (important ? (
          <Stack direction='row' gap={4} align='center' mt='4px'>
            <IconCircleCheck color={semantic_colors.state.negative} />
            <BaseText kind='Body_12_SemiBold' color={semantic_colors.state.negative}>
              {title}
            </BaseText>
          </Stack>
        ) : (
          <BaseText kind='Body_14_SemiBold' color={semantic_colors.content.primary}>
            {title}
          </BaseText>
        ))}
      <TabContainer direction='row' className={classNames('pds-panel-tab-group', className)}>
        {children}
      </TabContainer>
    </TabsContainer>
  );
};

const TabsContainer = styled(Stack)`
  display: flex;
  justify-content: space-between;
  gap: 8px;
`;

const TabContainer = styled(Stack)`
  display: flex;
  align-items: center;
  gap: 8px;
`;
